// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    aws_project_region: 'ap-southeast-2',
    aws_mobile_analytics_app_id: '886735e1e926468d8a0f0dd9fb24379f',
    aws_mobile_analytics_app_region: 'ap-southeast-2',
    Analytics: {
        AWSPinpoint: {
            appId: '886735e1e926468d8a0f0dd9fb24379f',
            region: 'ap-southeast-2',
        },
    },
    aws_appsync_graphqlEndpoint:
        'https://mkoqhq4yfrcujfzeyopjl4mhru.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'OPENID_CONNECT',
    aws_appsync_apiKey: 'da2-y5fmludo65conf5f4ctw3wtyzi',
    aws_cloud_logic_custom: [
        {
            name: 'tuhiDev',
            endpoint:
                'https://oh4gd9l4a0.execute-api.ap-southeast-2.amazonaws.com/uat',
            region: 'ap-southeast-2',
        },
    ],
    aws_cognito_identity_pool_id:
        'ap-southeast-2:0236483d-c6b6-4a7e-8fa8-10b05a3ea1e7',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_N2OTZwgi2',
    aws_user_pools_web_client_id: '5nivbhgrrq970u7cvdp8nulhld',
    oauth: {
        domain: 'tuhi-dev-uat.auth.ap-southeast-2.amazoncognito.com',
        scope: [
            'phone',
            'email',
            'openid',
            'profile',
            'aws.cognito.signin.user.admin',
        ],
        redirectSignIn: 'http://localhost:8081/,https://localhost:3000',
        redirectSignOut: 'http://localhost:8081/,https://localhost:3000',
        responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: [],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OFF',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_user_files_s3_bucket: 'tuhi-dev-bucketea751-uat',
    aws_user_files_s3_bucket_region: 'ap-southeast-2',
}

export default awsmobile
